<template>
  <main role="main">

    <section class="jumbotron text-center" style="width: 100%; display: flex; justify-content: center;">
      <div style="width: 90%; margin-top: -1cm">

        <div class="title1">鹰迅AI大模型</div>

        <p class="lead text-muted m-3 text-left">
          欢迎使用鹰迅AI大模型，1积分可以使用1次，注册即送1000积分，积分也可以在数字大侦探和剪刀石头布游戏中获得。
        </p>
        <hr>
        <p class="lead text-muted m-3 text-left">
          <br>
        </p>

        <div>
          <el-table :data="memberInfo">
            <el-table-column label="编号" prop="id"></el-table-column>
            <el-table-column label="用户名" prop="name"></el-table-column>
            <el-table-column label="AI可用次数" prop="points"></el-table-column>
            <el-table-column label="可用积分" prop="points"></el-table-column>
          </el-table>
        </div>
        <p>
          <br>
        </p>
        <hr>

        <template>
          <el-input
              type="textarea"
              placeholder="鹰迅AI大模型回复结果展示在这里~"
              :autosize="{ minRows: 3, maxRows: 5}"
              :value="resultText"
              maxlength="1500"
              show-word-limit
          >
          </el-input>
        </template>
        <p>
          <br>
        </p>

        <el-input
            type="textarea"
            placeholder="请输入内容"
            :autosize="{ minRows: 2, maxRows: 5}"
            v-model="queryParams.textValue"
            maxlength="1500"
            show-word-limit
        >
        </el-input>

        <p>
          <br>
        </p>

        <div class="input-with-button-container">
          <el-button type="primary" @click="send" size="medium" >发送</el-button>
        </div>

      </div>
    </section>
  </main>
</template>

<script>

  import TheCourse from "../components/the-course";
  export default {
    name: 'yxAI',
    components: {TheCourse},
    data: function () {
      return {
        resultText: '',
        memberInfo:[],
        tableData: [],
        queryParams: {
          textValue:'',
        },
      }
    },
    created() {
      let _this = this;
      _this.getMemberInfo();
    },

    methods: {

      getMemberInfo(){
        let _this = this;
        let loginMember = Tool.getLoginMember();
        if (Tool.isEmpty(loginMember)) {
          // Toast.warning("请先登录");
          return;
        }
        _this.queryParams.id = loginMember.id;
        console.log("queryParams:", _this.queryParams.id);
        _this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/member/getInfoById',
            _this.queryParams).then((response)=>{
          console.log("开始游戏：", response);
          _this.memberInfo = response.data;
          },
        )
        },

      send(){
        let _this = this;
        let loginMember = Tool.getLoginMember();
        if (Tool.isEmpty(loginMember)) {
          Toast.warning("请先登录");
          return;
        }
        _this.getMemberInfo();
        _this.queryParams.id = loginMember.id;
        console.log("queryParams:", _this.queryParams.id);
        _this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/member/yxAI',
            _this.queryParams).then((response)=>{
              console.log("开始游戏：", response);
              _this.resultText = response.data;
            },
        )
      },
    }
  }
</script>

<style>
  .title1{
    margin-bottom: 2rem;
    color: #fafafa;
    letter-spacing: 0;
    text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135;
    font-size: 2rem;
  }
  .title2{
    margin-bottom: 2rem;
    color: transparent;
    -webkit-text-stroke: 1px black;
    letter-spacing: 0.04em;
    font-size: 2rem;
  }
  .title {
    margin-bottom: 10px;
    font-size: 30px;
    color: #333;
    text-align: center;
  }

  .input-with-button-container {
    display: flex;
    align-items: center; /* 确保元素垂直居中对齐 */
    gap: 8px; /* 在两个元素间创建2字符（可以调整为所需的像素值）的间距 */
  }
</style>
